module.exports = __webpack_public_path__ + "assets/img/aa027fdb349ff3112c3138f874a08279.svg";